import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/examine/task/topic/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/examine/task/topic/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/examine/task/topic/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/examine/task/topic/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/examine/task/topic/submit', params,options);
